import { Box, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { Layout } from '@/apps/latest/components/templates/Layout'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { LineChat, useThreadQuery } from '@/features/internal/patient-messaging'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { scaledFontSize } from '@/shared/styles/typography'

const EMPTY_HINT = '左の一覧から選ぶと、ここにやり取りが出ます。'

// 患者との LINE のやり取り。一覧はサイドバー (MessagesPane) が持ち、ここは選んだ 1 件だけを出す。
// 開くと back が既読の時刻を進めるので、取れたたびに一覧を取り直してドットを消す (30 秒待たせない)。
export const MessagesPage = () => {
  const { threadId } = useParams<{ threadId?: string }>()
  const queryClient = useQueryClient()
  const { data, dataUpdatedAt } = useThreadQuery(threadId ?? null)

  useEffect(() => {
    if (!dataUpdatedAt) return
    queryClient.invalidateQueries({
      queryKey: queryKeys.patientMessaging.threads(),
    })
  }, [dataUpdatedAt, queryClient])

  const patientName = data?.patient.name_kanji
  return (
    <Layout breadcrumb={patientName ? ['やり取り', patientName] : ['やり取り']}>
      {threadId ? (
        // LineChat は自分の中で流す (入力欄を下に留める) ので、高さを渡す
        <Box sx={{ height: 'calc(100vh - 160px)' }}>
          <LineChat threadId={threadId} />
        </Box>
      ) : (
        <Typography
          component="p"
          sx={{
            fontSize: scaledFontSize('bodySm'),
            color: colorTokens.fg.muted,
          }}
        >
          {EMPTY_HINT}
        </Typography>
      )}
    </Layout>
  )
}

export default MessagesPage
